import { numberToDecimalString } from 'commons/utils/number'
import { Icon, StatisticsCard } from 'components'
import { useSelector } from 'store/store'

import * as S from './styles'

export const Statistics = () => {
  const { negotiationsStatistics } = useSelector((state) => state.negotiations)

  const {
    VolumeEmPares,
    ValorTotal,
    ValorExcedente,
    VolumeEmParesDentroForaDeLinha: dadosVolume,
    ValorTotalDentroForaDeLinha: dadosValorTotal,
    ValorExcedenteDentroForaDeLinha: dadosValorExcedente,
  } = negotiationsStatistics

  // TODO: Move to commons/utils/number or use formatToPTBRNumber?
  const formatCurrency = (value: number) =>
    new Intl.NumberFormat('pt-BR', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(value)

  return (
    <S.StatisticsRow>
      <StatisticsCard
        icon={<Icon color="#94A3BC" icon="sandal" size="25" />}
        mainValue={numberToDecimalString(VolumeEmPares)}
        title="Volume em pares"
      >
        <>
          <S.Item>
            <strong>Em linha</strong> {numberToDecimalString(dadosVolume.PercentualEmLinha)}% •{' '}
            {numberToDecimalString(dadosVolume.EmLinha)}
          </S.Item>
          <S.Item>
            <strong>Fora de linha</strong>{' '}
            {numberToDecimalString(dadosVolume.PercentualForaDeLinha)}% •{' '}
            {numberToDecimalString(dadosVolume.ForaDeLinha)}
          </S.Item>
        </>
      </StatisticsCard>
      <StatisticsCard
        icon={<Icon color="#94A3BC" icon="money" size="25" />}
        mainValue={formatCurrency(ValorTotal)}
        title="Valor Total (R$)"
      >
        <>
          <S.Item>
            <strong>Em linha</strong> {numberToDecimalString(dadosValorTotal.PercentualEmLinha)}% •{' '}
            {formatCurrency(dadosValorTotal.EmLinha)}
          </S.Item>
          <S.Item>
            <strong>Fora de linha</strong>{' '}
            {numberToDecimalString(dadosValorTotal.PercentualForaDeLinha)}% •{' '}
            {formatCurrency(dadosValorTotal.ForaDeLinha)}
          </S.Item>
        </>
      </StatisticsCard>
      <StatisticsCard
        icon={<Icon color="#94A3BC" icon="trending-up" size="25" />}
        mainValue={formatCurrency(ValorExcedente)}
        title="Excedente total (R$)"
      >
        <>
          <S.Item>
            <strong>Em linha</strong> {numberToDecimalString(dadosValorExcedente.PercentualEmLinha)}
            % • {formatCurrency(dadosValorExcedente.EmLinha)}
          </S.Item>
          <S.Item>
            <strong>Fora de linha</strong>{' '}
            {numberToDecimalString(dadosValorExcedente.PercentualForaDeLinha)}% •{' '}
            {formatCurrency(dadosValorExcedente.ForaDeLinha)}
          </S.Item>
        </>
      </StatisticsCard>
    </S.StatisticsRow>
  )
}
